<div class="container">
  @if (evaluation) {
  <mat-card appearance="raised" class="card-evaluation">
    <mat-card-header class="fx-direction-row fx-between-start">
      <div mat-card-avatar style="margin-bottom: 0;">
        <div>N°{{ evaluation.numEvaluation }}</div>
      </div>
      <mat-card-title class="fx-direction-row fx-start-center">
        @if(evaluation.examen){
        <app-icon type="do" icon="groupe-commission" style="margin-right: 10px;" />
        }@else {
        <app-icon type="do" icon="evaluation" style="margin-right: 10px;" />
        }
        <span>{{ evaluation.libelle.libelle }}</span>
      </mat-card-title>
      <div class="fx-direction-row fx-start-center">
        <app-icon style="margin-right: 5px;" type="do" icon="annee-scolaire" />
        <span class="label-anneeScolaire" matTooltip="Année scolaire">{{ evaluation.anneeScolaireName }}</span>
      </div>
    </mat-card-header>
    <mat-card-content class="fx-flex-1 card-content">
      <div class="info-eval">
        <div>
          <app-icon type="do" icon="date-range" style="margin-right: 5px;" />
          <!-- <label>Date : </label>  -->
          @if (evaluation.dateDebut === evaluation.dateFin) {
          {{evaluation.dateDebut | date:'shortDate'}}
          }@else{
          Du {{evaluation.dateDebut | date:'shortDate'}} au {{evaluation.dateFin |
          date:'shortDate'}}
          }
        </div>
        <div>
          <app-icon type="do" icon="departement" style="margin-right: 5px;" />
          <!-- <label>Département : </label> -->
          {{ evaluation.departement }}
        </div>
        @if (evaluation.discipline) {
        <div><app-icon type="do" icon="discipline" style="margin-right: 5px;" />
          <!-- <label>Discipline : </label> -->
          {{evaluation.discipline.libelle}}
        </div>
        }
        @if (evaluation.cours) {
        <div><app-icon type="do" icon="cours" style="margin-right: 5px;" />
          <!-- <label>Cours : </label> -->
          {{evaluation.cours.libelle}}
        </div>
        }
      </div>

      <div class="accordion-scroll-wrapper">
        <mat-accordion class="thin-scrollbar">
          @for(inscription of evaluationInscriptions();track $index;let idx = $index; let first = $first; let
          last
          =
          $last;){
          <mat-expansion-panel #panel [disabled]="!inscription.selected()">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-slide-toggle [checked]="inscription.selected()" (change)="inscription.selected.set($event.checked)"
                  style="margin-inline: 10px;" (click)="$event.stopPropagation()"
                  [matTooltip]="evaluation.examen ? 'Inscription à l\'examen' : 'Inscription à l\'évaluation'"
                  color="primary"></mat-slide-toggle>
                @if(evaluation.examen){
                <mat-icon [style.color]="inscription.reussiteExamen ? '#6EBF6D' : '#DA5255'"
                  [matTooltip]="inscription.reussiteExamen ? 'Réussite à l\'examen' : 'Échec à l\'examen'"
                  style="min-width: 24px;">{{inscription.reussiteExamen
                  ?
                  'check_circle' : 'cancel'}}</mat-icon>
                }
                <span style="margin-left: 5px;">{{inscription.nomReferent}}</span>
                @if(config?.showOtherTeachersEvaluations){
                <button mat-icon-button [matTooltip]="'Voir toutes les évaluations de ' + inscription.nomReferent"
                  (click)="openDialogEvaluationsByInscription(inscriptionInfoEvaluation,inscription);$event.stopPropagation()"
                  color="accent">
                  <mat-icon>info</mat-icon>
                </button>
                }
              </mat-panel-title>
              <mat-panel-description>
                <span>{{inscription.appreciation}}</span>
                @if(inscription.noteGlobale){
                <span class="note" matTooltip="Note globale">{{inscription.noteGlobale}}</span>
                }
              </mat-panel-description>
            </mat-expansion-panel-header>
            <form class="form-evaluation">
              @if (evaluation.criteresNotation && inscription.criteresData){
              <div class="critere-zone">
                <div class="fx-direction-row fx-wrap fx-gap-5">
                  @for (critere of evaluation.criteresNotation; track $index) {
                  @switch (critere.type) {
                  @case ("numerique") {
                  <div class="form-field-critere">
                    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
                      <mat-label>{{critere.critere}}</mat-label>
                      <input matInput [(ngModel)]="inscription.criteresData[critere.id]"
                        [disabled]="!inscription.selected()"
                        (ngModelChange)="recalculerNoteGlobale(idx);actualiserReussite(idx)" type="number"
                        name="critere_{{critere.id}}">
                    </mat-form-field>
                  </div>

                  }
                  @case ("checkbox") {
                  <div class="form-field-critere fx-direction-row fx-align-item-center">
                    <mat-checkbox style="width: 100%;" [(ngModel)]="inscription.criteresData[critere.id]"
                      name="critere_{{critere.id}}" (ngModelChange)="actualiserReussite(idx)"
                      [disabled]="!inscription.selected()">{{critere.critere}}</mat-checkbox>
                  </div>

                  }
                  @case ("liste") {
                  <div class="form-field-critere">
                    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
                      <mat-label>{{critere.critere}}</mat-label>
                      <mat-select [(ngModel)]="inscription.criteresData[critere.id]"
                        (ngModelChange)="actualiserReussite(idx)" [disabled]="!inscription.selected()"
                        name="critere_{{critere.id}}">
                        <mat-option>--</mat-option>
                        @for (valeur of critere.valeurs; track valeur) {
                        <mat-option [value]="valeur.id">{{valeur.libelle}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  }
                  @case ("texte") {
                  <div class="form-field-critere" style="width: 100%;">
                    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
                      <mat-label>{{critere.critere}}</mat-label>
                      <textarea matInput [(ngModel)]="inscription.criteresData[critere.id]"
                        [disabled]="!inscription.selected()" (ngModelChange)="actualiserReussite(idx)"
                        name="critere_{{critere.id}}" cdkTextareaAutosize cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="3"></textarea>
                    </mat-form-field>
                  </div>

                  }
                  }
                  }
                </div>
              </div>
              }
              <div class="appreciation-zone" [class.full-width]="!evaluation.criteresNotation?.length">
                <mat-form-field style="width: 100%;">
                  <mat-label>Appréciation</mat-label>
                  <textarea matInput [(ngModel)]="inscription.appreciation" name="appréciation"
                    [disabled]="!inscription.selected()" cdkTextareaAutosize cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="8"></textarea>
                </mat-form-field>
              </div>
            </form>
          </mat-expansion-panel>
          }@empty {
          <div class="no-inscription-container">
            {{'enseignant_evaluation.no_inscriptions' | trans}}
          </div>
          }
        </mat-accordion>
      </div>

    </mat-card-content>
    <mat-card-actions align="end">
      <button color="primary" mat-raised-button aria-label="Enregistrer" (click)="saveEvaluation(evaluation)"
        [disabled]="!evaluationInscriptions().length || saving">

        <mat-icon [hidden]="saving">save</mat-icon>
        <div class="fx-direction-row fx-align-item-center fx-gap-5">
          @if (saving) {
          <mat-progress-spinner mode="indeterminate" strokeWidth="2" diameter="18"
            color="accent"></mat-progress-spinner>
          }
          <span>Enregistrer</span>
        </div>

      </button>
    </mat-card-actions>
  </mat-card>

  }@else {
  <app-loader message="Chargement des données..." class="margin" />
  }

</div>

<ng-template #inscriptionInfoEvaluation let-data>

  @let evalInscription = data.evalInscrData();

  <app-dialog-header [title]="'Évaluations ' + data.nomReferent" />
  <mat-dialog-content class="content-dialog">
    @if(!evalInscription.loading){
    <mat-accordion style="display: block;">
      @for (item of evalInscription.result; track $index) {

      @let evaluation = item.evaluation;
      @let evalInscription = item.evaluationInscription;

      @if(evaluation.idEvaluation !== data.idEvaluation){
      <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-header-dialog" style="height: auto; min-height: 60px;">
          <mat-panel-title>
            @if(evaluation.examen){
            <app-icon type="do" icon="groupe-commission" style="margin-right: 10px;" matTooltip="Examen"
              class="primary" />
            }@else {
            <app-icon type="do" icon="evaluation" style="margin-right: 10px;" matTooltip="Évaluation" class="primary" />
            }

            <span style="margin-inline: 3px;">{{evaluation.libelle}}</span>

          </mat-panel-title>
          <mat-panel-description>
            <div class="fx-direction-row">
              <app-icon type="do" icon="date-range" style="margin-right: 5px;" class="primary" />
              <!-- <label>Date : </label>  -->
              @if (evaluation.dateDebut === evaluation.dateFin) {
              {{evaluation.dateDebut | date:'shortDate'}}
              }@else{
              Du {{evaluation.dateDebut | date:'shortDate'}} au {{evaluation.dateFin |
              date:'shortDate'}}
              }
            </div>
            @if (evaluation.cours) {
            <div class="fx-direction-row">
              <app-icon type="do" icon="cours" style="margin-right: 5px;" class="primary" matTooltip="cours" />
              {{evaluation.cours.libelle}}
            </div>
            }
            @if (evaluation.discipline) {
            <div class="fx-direction-row">
              <app-icon type="do" icon="discipline" style="margin-right: 5px;" class="primary"
                matTooltip="Discipline" />
              {{evaluation.discipline.libelle}}
            </div>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="container-global-info" style="margin-bottom: 10px;">
          @if(evaluation.examen){
          <mat-card appearance="outlined" class="evaluation-card reussite-card">
            <label class="evaluation-label">Réussite à l'examen</label>
            <mat-card-content class="evaluation-content fx-center-center" style="padding-bottom: 0;">
              <mat-icon [style.color]="evalInscription.reussiteExamen ? '#6EBF6D' : '#DA5255'"
                [matTooltip]="evalInscription.reussiteExamen ? 'Réussite à l\'examen' : 'Échec à l\'examen'"
                style="font-size: 36px;height: 36px; width: 36px;">{{evalInscription.reussiteExamen
                ?
                'check_circle' : 'cancel'}}</mat-icon>
            </mat-card-content>
          </mat-card>
          }

          @if(evalInscription.noteGlobale){
          <mat-card appearance="outlined" class="evaluation-card note-globale-card">
            <label class="evaluation-label">Note globale</label>
            <mat-card-content class="evaluation-content fx-center-center" style="padding-bottom: 0;">
              <span class="note" matTooltip="Note globale">{{evalInscription.noteGlobale}}</span>
            </mat-card-content>
          </mat-card>
          }

          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">Appréciation</label>
            <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
              {{ evalInscription.appreciation }}
            </mat-card-content>
          </mat-card>
        </div>

        @if (evaluation.criteresNotation && evalInscription.criteresData){
        <div class="fx-direction-row fx-wrap fx-gap-10">
          @for (critere of evaluation.criteresNotation; track $index) {

          @switch (critere.type) {

          @case ('texte') {
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">{{ critere.critere }}</label>
            <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
              {{ evalInscription.criteresData[critere.id] }}
            </mat-card-content>
          </mat-card>
          }

          @case ('numerique') {
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">{{ critere.critere }}</label>
            <mat-card-content class="evaluation-content fx-center-center" style="padding-bottom: 0;">
              <span class="note">{{ evalInscription.criteresData[critere.id] }}</span>
            </mat-card-content>
          </mat-card>
          }

          @case('checkbox'){
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">{{ critere.critere }}</label>
            <mat-card-content class="evaluation-content fx-center-center" style="padding-bottom: 0;">
              @if (evalInscription.criteresData[critere.id]) {
              <mat-icon style="font-size: 36px;height: 36px; width: 36px; color:#6EBF6D">check_circle</mat-icon>
              }@else {
              <mat-icon color="warn" style="font-size: 36px;height: 36px; width: 36px; color:#DA5255">cancel</mat-icon>
              }
            </mat-card-content>
          </mat-card>
          }

          @case('liste'){
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">{{ critere.critere }}</label>
            <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
              @for (valeur of critere.valeurs; track valeur) {
              @if(valeur.id === evalInscription.criteresData[critere.id]){
              {{valeur.libelle}}
              }
              }
            </mat-card-content>
          </mat-card>
          }
          }
          }
        </div>
        }
      </mat-expansion-panel>
      }
      }@empty {
      <div style="padding: 50px; text-align: center;">
        Aucune évaluation
      </div>
      }
    </mat-accordion>
    }@else {<app-loader style="padding: 50px;" message="Chargement des données..." />}
  </mat-dialog-content>
</ng-template>